import { Box, Grid, Typography } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { FC, useState } from 'react';

import { IconCircleCheck } from 'src/general/Icons/IconCircleCheck';
import useStyles, { Accordion, AccordionDetails, AccordionSummary } from './InspectionCheckList.style';

export interface Props {
  title: string;
  data?: {
    icon: string;
    question: string;
    listDataChildren: {
      answer: string;
      checkAnswer: string;
      iconSuccess: string;
    }[];
  }[];
}

const InspectionCheckList: FC<Props> = ({ title, data }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState<string[]>([]);
  const handleChange = (panel: any) => (_event: any, isExpanded: any) => {
    if (isExpanded && !expanded.includes(panel)) {
      setExpanded([panel, ...expanded]);
    } else if (!isExpanded) {
      setExpanded(expanded.filter((e) => e !== panel));
    }
  };

  function Question({ icon, question }: { icon: string; question: string }) {
    return (
      <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1bh-content" id="panel1bh-header">
        <Grid item md={12} xs={12} className={classes.gridItem}>
          <img className={classes.imageIcon} src={icon} alt="icon" />
          <Typography className="c-fw-bold" variant="body1">
            {question}
          </Typography>
        </Grid>
      </AccordionSummary>
    );
  }

  function Detail({
    listDataChildren,
  }: {
    listDataChildren: { answer: string; checkAnswer: string; iconSuccess: string }[];
  }) {
    return (
      <AccordionDetails>
        {listDataChildren?.length &&
          listDataChildren?.map((item, index) => (
            <Grid container key={index} className={classes.gridItemDetail}>
              <Grid item className={classes.answerBox} xs={10}>
                <Typography variant="body2">{item.answer}</Typography>
                <Typography variant="body2">{item.checkAnswer}</Typography>
              </Grid>
              <Grid item className={classes.tickContainer} xs={2}>
                <IconCircleCheck className="image" />
              </Grid>
            </Grid>
          ))}
      </AccordionDetails>
    );
  }

  const sectionList = (
    <>
      {data?.length &&
        data?.map((e) => {
          const { icon } = e;
          return (
            <Accordion expanded={expanded.includes(icon)} square key={icon} onChange={handleChange(icon)}>
              <Question {...e} />
              <Detail {...e} />
            </Accordion>
          );
        })}
    </>
  );

  return (
    <Grid container md={12} className={`${classes.root} column  `}>
      <Grid item className={classes.boxItem}>
        <Typography variant="h4" className={`${classes.title} c-fw-bold`}>
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }}>
          <Grid item xs={12} xl={12} className={classes.container}>
            {sectionList}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default InspectionCheckList;
